import axiosInstance from './axiosInstance'

export const getCommunicationOptionById = (optionId) => {
  return axiosInstance.get(`/communication-options/${optionId}`)
}

export const getCommunicationOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/communication-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createCommunicationOption = (data) => {
  return axiosInstance.post('/communication-options', data)
}

export const updateCommunicationOption = (optionId, data) => {
  return axiosInstance.put(`/communication-options/${optionId}`, data)
}

export const deleteCommunicationOption = (optionId) => {
  return axiosInstance.delete(`/communication-options/${optionId}`)
}
